import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';
import miscUtils from '../../../utils/miscUtils';

class DocV1Summarize extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_SUMMARIZE)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <span className="heading-1">Summarize</span>
                <code className="api-definition">
                    <span className="post-badge">POST</span>&nbsp;{urlHandler.API_ENDPOINT_V1_SUMMARIZE}
                </code>
                <div className="description">
                    The summarize endpoint uses Artificial Intelligence (AI) to summarize a piece of text. The "News" model 
                    is the recommended model. The number of sentences in the summary may be limited with the <i>maxSentences</i> parameter.
                </div>

                <h4 className="heading-2" id="summarizev1_request">Request</h4>
                <div className="description">
                    The summarize request is a JSON object that contains the request parameters.
                </div>

                <h4 className="heading-3" id="summarizev1_request_object">Request object</h4>

                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">documentId</td>
                        <td className="meaning">A client supplied tracking identifier.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">text</td>
                        <td className="meaning">The UTF-8 block of text to be summarized.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required    
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">languageCode</td>
                        <td className="meaning">Language of the text, specified as an {miscUtils.createExternalLink('https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes','ISO 639-1 code')}.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required. Supported languages include: <i>en</i>, <i>de</i>, <i>fr</i>, <i>es</i>, <i>nl</i>.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">maxSentences</td>
                        <td className="meaning">The maximum number of sentences that should be included in the summary.
                        </td>
                        <td className="type">Integer</td>
                        <td className="constraints">Optional. Default: 5
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">summaryModel</td>
                        <td className="meaning">The summary model chosen for summarization analysis.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required. See <a href="#summarize_models">summary models</a> for supported models.
                        </td>
                    </tr>
                    </tbody>
                </table> 

                <h4 className="heading-3" id="summarize_models">Summary Models</h4>
                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Model Name </th>
                        <th>Model Description </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">News</td>
                        <td className="meaning">Hybrid news summarization model trained on a diverse corpus of news (recommended model for news).</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2" id="summarizev1_response">Response</h4>
                <div className="description">
                    The summarize response object contains a summary of the request text and optionally may include an 
                    array of the summary sentences.
                </div>

                <h4 className="heading-3" id="summarizev1_response_object">Response object</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">summary</td>
                        <td className="meaning">A summarization of the request text.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Optional. Currently summary will exist for <i>en</i> text only.</td>
                    </tr>
                    <tr>
                        <td className="attribute">summarySentences</td>
                        <td className="meaning">An array of summarized sentences from the request text.
                        </td>
                        <td className="type">String[]</td>
                        <td className="type">Optional</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2" id="summarizev1_response_object">Example</h4>
                <div className="example-content host">
                    <pre>
                        POST {urlHandler.API_ENDPOINT_V1_SUMMARIZE}<br/>
                        Accept: application/json<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                        Content-Type: application/json<br/>
                        <br/>
                    </pre>
                    <pre>{JSON.stringify(examples.EXAMPLE_REQUEST_V1_SUMMARIZE, null, 3)}</pre>
                </div>
                <HttpRunner example="summarize1" 
                    query="summarize"
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_V1_SUMMARIZE) : null}
                />
            </div>
        );
    }
}

export default DocV1Summarize;